<nz-header>
	<nz-row type="flex" nzJustify="space-between">
		<nz-col class="logo-brand-app">
			<div class="logo"></div>
			<div class="app-title">MyEcom<span>{{currEnvVer | async}}</span></div>
		</nz-col>
		<nz-col class="niq-header-menu" *ngIf="isLoggedIn$ | async">
			<ul nz-menu nzMode="horizontal">
				<ng-container *ngFor='let nav of navList'>
					<ng-container *ngIf='hasChildrenNav(nav); else topMenus'>
						<li nz-submenu nzMenuClassName="niq-header-submenu" [nzTitle]="nav.name[currLang] || null"
							[nzIcon]="nav.icon || null">
							<ul>
								<li nz-menu-item *ngFor='let subNav of getChildrenNav(nav.children || [])'
									nzMatchRouter>
									<i nz-icon *ngIf='!!subNav.icon' [nzType]="subNav.icon"></i>
									<a [routerLink]="[subNav.path]">{{subNav.name[currLang]}}</a>
								</li>
							</ul>
						</li>
					</ng-container>
					<ng-template #topMenus>
						<li nz-menu-item nzMatchRouter *ngIf='nav.type === rescType.ROUTE'>
							<i nz-icon *ngIf='!!nav.icon' [nzType]="nav.icon"></i>
							<a [routerLink]="[nav.path]"
								[state]="{attrCfg: getChildrenAttrCfg(nav)}">{{nav.name[currLang]}}</a>
						</li>
					</ng-template>
				</ng-container>
			</ul>
		</nz-col>

		<nz-col *ngIf='!disableTheme'>
			<app-theme-change></app-theme-change>
		</nz-col>
		<nz-col *ngIf="(isLoggedIn$ | async) && !disableUserProfile">
			<div class="header-item" nz-dropdown nzOverlayClassName="drop-down-list-body" [nzDropdownMenu]="userAccount"
				nzPlacement="bottomCenter">
				<svg width="24" height="24">
					<use xlink:href="#account-icon"></use>
				</svg>
			</div>
			<nz-dropdown-menu #userAccount="nzDropdownMenu">
				<ul nz-menu nzSelectable>
					<li (click)="navMenuClick('/user/profile')" nz-menu-item>
						{{ 'menu.profile' | translate }}
					</li>
					<li (click)="logout()" nz-menu-item>{{ 'action.signOut' | translate}}</li>
				</ul>
			</nz-dropdown-menu>
			<nz-badge class="header-badge" (click)="showIncentiveModal()" nzStandalone
				[nzCount]="incentiveCount"></nz-badge>
		</nz-col>
	</nz-row>
</nz-header>

<svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
	<symbol id="account-icon" viewBox="0 0 24 24">
		<title>Account Icon</title>
		<path stroke-linecap="round" stroke-linejoin="round" stroke-width=".5" fill="currentColor"
			d="M12.0004919,2 C14.9886047,2 17.4109488,4.46243388 17.4109488,7.5 C17.4109488,9.5597022 16.2971847,11.3549656 14.6484833,12.2973839 L20.460623,15.1416122 L22,22 L2,22 L3.54036072,15.1416122 L9.3525004,12.2973839 C7.70379902,11.3549656 6.59003492,9.5597022 6.59003492,7.5 C6.59003492,4.46243388 9.012379,2 12.0004919,2 Z M12.0004919,13.219 L5.24725788,16.525 L4.466,20 L19.533,20 L18.7527421,16.525 L12.0004919,13.219 Z M12.0004919,4 C10.0989655,4 8.55747381,5.56700338 8.55747381,7.5 C8.55747381,9.43299662 10.0989655,11 12.0004919,11 C13.9020182,11 15.4435099,9.43299662 15.4435099,7.5 C15.4435099,5.56700338 13.9020182,4 12.0004919,4 Z">
		</path>
	</symbol>
</svg>

<app-incentive-modal *ngIf='(isLoggedIn$ | async) && incentiveEnable' (closeEvt)='onInentiveModalClose($event)'
	#incentiveModal></app-incentive-modal>
